import React, { useState, useEffect } from "react"
import Layout from "../../components/Layout"
import axios, { Axios } from "axios"
import { useParams, useNavigate } from "react-router-dom"
import styles from "./DetailKelas.module.css"
import { InfoProgram, SilabusMateri, FasilitasPelatihan } from "./components"
import BelajarMandiri from "../../components/BelajarMandiri"

import { message, Spin } from "antd"
import { Link } from "react-router-dom"
import { ReactComponent as IcArrowRight } from "../../assets/icon/ic-arrow-right.svg"

import "./DetailKelas.scss"
import { useSelector } from "react-redux"
import { selectCurrentUser } from "../../redux/user/user.selectors"
import PersiapanKelas from "./components/PersiapanKelas"

const DetailKelas = () => {
  const currentUser = useSelector(selectCurrentUser)
  const [dataUser, setDataUser] = useState(null)
  const [program, setProgram] = useState(null)
  let { slug } = useParams()
  let navigate = useNavigate()

  useEffect(() => {
    redirectToClass()    
  }, [slug, navigate, currentUser])

  function getClassDetail(){
    axios({
      method: "get",
      url: `/user-classroom/${slug}`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setProgram(data)
      })
      .catch((error) => {
        if (error.response.status === 500) {
          message.error("We are Under Maintenance")
        }
      })
    if (currentUser) {
      axios({
        method: "get",
        url: "/profile",
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      }).then(({ data }) => {
        setDataUser(data)
      })
    }
  }

  function redirectToClass() {
    axios({
      method: "get",
      url: `/user-classroom/generate-signature/${slug}`,      
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    }).then(({ data }) => {
      window.location.href = `https://classroom-mindo-525fx.ondigitalocean.app/portal?token=${data.data.signature}`
      console.log("data signature", data)
    }).catch(err => {
      console.log('err', err)
      getClassDetail()
    })
  }

  return (
    <Layout idPage="program-detail-page">
      {program === null ? (
        <div className="loadingContainer">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="container">
            <InfoProgram program={program} dataUser={dataUser} />
            <div className={`${styles.silabusFasilitasGroup}`}>
              <div className={styles.detailProgramCard}>
                <div className={styles.detailProgramCardInner}>
                  <SilabusMateri program={program} />
                </div>
              </div>
              <div className={styles.detailProgramCard}>
                <div className={styles.detailProgramCardInner}>
                  <PersiapanKelas program={program} />
                </div>
                <div
                  className={styles.detailProgramCardInner}
                  style={{ marginTop: 30 }}>
                  <FasilitasPelatihan program={program} />
                </div>
              </div>
            </div>
            <div className={styles.btnLinkToProgram}>
              <Link to="/program">
                <button type="button" className={`btn btn-primary btn-w-icon`}>
                  Lihat Semua Pelatihan
                  <IcArrowRight />
                </button>
              </Link>
              {/* TODO akses generate signature pada node js */}
              {/* <button
                onClick={redirectToClass}
                type="button"
                style={{ marginLeft: "10px" }}
                className={`btn btn-primary btn-w-icon`}>
                Akses Kelas
              </button> */}
            </div>
          </div>
          <BelajarMandiri />
        </>
      )}
    </Layout>
  )
}

export default DetailKelas
